module.exports = __webpack_public_path__ + "static/img/home_swipe_returnscore_jinri.f593031d.png";